// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subheading {
    font-weight: var(--sub-heading-font-weight);
    font-size: 18px;
    letter-spacing: 0.3px;
}

.primarybutton {
    background: linear-gradient(90deg, #ffffff 0%, #a3a3a3 100%);
    color: #000000;
    border: none;
    padding: 16px 55px;
    border-radius: 999px;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;
    transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    letter-spacing: 0.2px;
}

.primarybutton:hover {
    opacity: 85%;
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.primarybutton:active {
    transform: translateY(0);
}

.secondarybutton {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 0.04);
    box-shadow:
        inset 0 1.5px 1px rgba(255, 255, 255, 0.15),
        inset 0 0 8px rgba(150, 100, 255, 0.05),
        0 4px 15px rgba(0, 0, 0, 0.3);
    color: #ffffff;
    padding: 16px 55px;
    border-radius: 999px;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;
    transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
    letter-spacing: 0.2px;
}

.secondarybutton:hover {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.05) 100%);
    box-shadow:
        inset 0 1.5px 1px rgba(255, 255, 255, 0.25),
        inset 0 0 12px rgba(150, 100, 255, 0.1),
        0 6px 20px rgba(0, 0, 0, 0.4);
    transform: translateY(-2px);
}

.secondarybutton:active {
    transform: translateY(0);
}

.ButtonStyleHeading {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 28px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    background: linear-gradient(180deg, rgba(40, 40, 50, 0.8) 0%, rgba(15, 15, 20, 0.8) 100%);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 999px;
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow:
        inset 0 0 15px rgba(255, 255, 255, 0.05),
        0 4px 20px rgba(0, 0, 0, 0.8);
    margin: 0;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    -webkit-user-select: none;
            user-select: none;
    margin-bottom: 50px;
}

.ButtonStyleHeading::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 15%;
    right: 15%;
    height: 2px;
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(255, 255, 255, 0.3) 30%,
            rgba(255, 255, 255, 1) 50%,
            rgba(255, 255, 255, 0.3) 70%,
            transparent 100%);
    box-shadow: 0 -2px 10px rgba(255, 255, 255, 0.4);
    border-radius: 50%;
}

.Primarysubheading {
    font-size: clamp(36px, 5vw, 68px);
    font-weight: 500;
    text-align: center;
    background: var(--heading-gradient);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    line-height: 1.05;
    letter-spacing: -2.5px;
    margin: 32px 0 0 0;
    max-width: 900px;
}

[data-theme="light"] .ButtonStyleHeading {
    background: linear-gradient(180deg, rgba(220, 220, 230, 0.9) 0%, rgba(200, 200, 210, 0.9) 100%);
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow:
        inset 0 0 15px rgba(0, 0, 0, 0.03),
        0 4px 20px rgba(0, 0, 0, 0.06);
    color: #000000;

}

[data-theme="light"] .ButtonStyleHeading::after {
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(0, 0, 0, 0.15) 30%,
            rgba(0, 0, 0, 0.4) 50%,
            rgba(0, 0, 0, 0.15) 70%,
            transparent 100%);
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);

}

[data-theme="light"] .secondarybutton {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.06) 0%, rgba(0, 0, 0, 0.02) 100%);
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow:
        inset 0 1.5px 1px rgba(255, 255, 255, 0.8),
        0 4px 15px rgba(0, 0, 0, 0.06);
    color: #000000;
}

[data-theme="light"] .secondarybutton:hover {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.04) 100%);
    box-shadow:
        inset 0 1.5px 1px rgba(255, 255, 255, 0.9),
        0 6px 20px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {

    .primarybutton,
    .secondarybutton {
        padding: 14px 40px;
        font-size: 16px;
    }

    .Primarysubheading {
        letter-spacing: -1.5px;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;IAC3C,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,4DAA4D;IAC5D,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mDAAmD;IACnD,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iGAAiG;IACjG,2BAA2B;IAC3B,mCAAmC;IACnC,2CAA2C;IAC3C;;;qCAGiC;IACjC,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mDAAmD;IACnD,qBAAqB;AACzB;;AAEA;IACI,iGAAiG;IACjG;;;qCAGiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yFAAyF;IACzF,2BAA2B;IAC3B,mCAAmC;IACnC,oBAAoB;IACpB,kBAAkB;IAClB,0CAA0C;IAC1C;;qCAEiC;IACjC,SAAS;IACT,qBAAqB;IACrB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,WAAW;IACX;;;;;6BAKyB;IACzB,gDAAgD;IAChD,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+FAA+F;IAC/F,qCAAqC;IACrC;;sCAEkC;IAClC,cAAc;;AAElB;;AAEA;IACI;;;;;6BAKyB;IACzB,0CAA0C;;AAE9C;;AAEA;IACI,qFAAqF;IACrF,qCAAqC;IACrC;;sCAEkC;IAClC,cAAc;AAClB;;AAEA;IACI,oFAAoF;IACpF;;qCAEiC;AACrC;;AAEA;;IAEI;;QAEI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".subheading {\n    font-weight: var(--sub-heading-font-weight);\n    font-size: 18px;\n    letter-spacing: 0.3px;\n}\n\n.primarybutton {\n    background: linear-gradient(90deg, #ffffff 0%, #a3a3a3 100%);\n    color: #000000;\n    border: none;\n    padding: 16px 55px;\n    border-radius: 999px;\n    font-size: 18px;\n    font-weight: 500;\n    cursor: pointer;\n    font-family: inherit;\n    transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    letter-spacing: 0.2px;\n}\n\n.primarybutton:hover {\n    opacity: 85%;\n    transform: translateY(-2px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n}\n\n.primarybutton:active {\n    transform: translateY(0);\n}\n\n.secondarybutton {\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);\n    backdrop-filter: blur(16px);\n    -webkit-backdrop-filter: blur(16px);\n    border: 1px solid rgba(255, 255, 255, 0.04);\n    box-shadow:\n        inset 0 1.5px 1px rgba(255, 255, 255, 0.15),\n        inset 0 0 8px rgba(150, 100, 255, 0.05),\n        0 4px 15px rgba(0, 0, 0, 0.3);\n    color: #ffffff;\n    padding: 16px 55px;\n    border-radius: 999px;\n    font-size: 18px;\n    font-weight: 500;\n    cursor: pointer;\n    font-family: inherit;\n    transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);\n    letter-spacing: 0.2px;\n}\n\n.secondarybutton:hover {\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.05) 100%);\n    box-shadow:\n        inset 0 1.5px 1px rgba(255, 255, 255, 0.25),\n        inset 0 0 12px rgba(150, 100, 255, 0.1),\n        0 6px 20px rgba(0, 0, 0, 0.4);\n    transform: translateY(-2px);\n}\n\n.secondarybutton:active {\n    transform: translateY(0);\n}\n\n.ButtonStyleHeading {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 28px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #ffffff;\n    background: linear-gradient(180deg, rgba(40, 40, 50, 0.8) 0%, rgba(15, 15, 20, 0.8) 100%);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    border-radius: 999px;\n    position: relative;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    box-shadow:\n        inset 0 0 15px rgba(255, 255, 255, 0.05),\n        0 4px 20px rgba(0, 0, 0, 0.8);\n    margin: 0;\n    letter-spacing: 0.4px;\n    text-transform: uppercase;\n    user-select: none;\n    margin-bottom: 50px;\n}\n\n.ButtonStyleHeading::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 15%;\n    right: 15%;\n    height: 2px;\n    background: linear-gradient(90deg,\n            transparent 0%,\n            rgba(255, 255, 255, 0.3) 30%,\n            rgba(255, 255, 255, 1) 50%,\n            rgba(255, 255, 255, 0.3) 70%,\n            transparent 100%);\n    box-shadow: 0 -2px 10px rgba(255, 255, 255, 0.4);\n    border-radius: 50%;\n}\n\n.Primarysubheading {\n    font-size: clamp(36px, 5vw, 68px);\n    font-weight: 500;\n    text-align: center;\n    background: var(--heading-gradient);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    color: transparent;\n    line-height: 1.05;\n    letter-spacing: -2.5px;\n    margin: 32px 0 0 0;\n    max-width: 900px;\n}\n\n[data-theme=\"light\"] .ButtonStyleHeading {\n    background: linear-gradient(180deg, rgba(220, 220, 230, 0.9) 0%, rgba(200, 200, 210, 0.9) 100%);\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    box-shadow:\n        inset 0 0 15px rgba(0, 0, 0, 0.03),\n        0 4px 20px rgba(0, 0, 0, 0.06);\n    color: #000000;\n\n}\n\n[data-theme=\"light\"] .ButtonStyleHeading::after {\n    background: linear-gradient(90deg,\n            transparent 0%,\n            rgba(0, 0, 0, 0.15) 30%,\n            rgba(0, 0, 0, 0.4) 50%,\n            rgba(0, 0, 0, 0.15) 70%,\n            transparent 100%);\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n\n}\n\n[data-theme=\"light\"] .secondarybutton {\n    background: linear-gradient(180deg, rgba(0, 0, 0, 0.06) 0%, rgba(0, 0, 0, 0.02) 100%);\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    box-shadow:\n        inset 0 1.5px 1px rgba(255, 255, 255, 0.8),\n        0 4px 15px rgba(0, 0, 0, 0.06);\n    color: #000000;\n}\n\n[data-theme=\"light\"] .secondarybutton:hover {\n    background: linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.04) 100%);\n    box-shadow:\n        inset 0 1.5px 1px rgba(255, 255, 255, 0.9),\n        0 6px 20px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 768px) {\n\n    .primarybutton,\n    .secondarybutton {\n        padding: 14px 40px;\n        font-size: 16px;\n    }\n\n    .Primarysubheading {\n        letter-spacing: -1.5px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
